import React, {FunctionComponent, ReactElement, useState} from 'react'
import {faChevronDown, faGifts} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'

import IProps, {IAction, IButtonColor} from './IProps'
import style from './Button.scss'

const Button: FunctionComponent<IProps> = (
    {
        type = 'button',
        onClick,
        buttonStyle,
        disabled = false,
        actions = [],
        children,
        size,
        color,
        cssStyle
    }
) => {
    const [isOpen, setOpen] = useState<boolean>(false)
    const [isHover, setIsHover] = useState<boolean>(false)

    let customButtonColor: IButtonColor = {}
    if (color && buttonStyle !== 'dim') {
        customButtonColor = {
            borderColor: color,
            color
        }
    }

    const iconMap = {
        'holiday': faGifts
    }

    const classNames: string[] = [style.button]

    if (disabled) {
        classNames.push(style.dim)
    } else if (buttonStyle) {
        classNames.push(style[buttonStyle])
    }

    if (isHover && color) {
        customButtonColor.backgroundColor = color
        customButtonColor.color = 'white'
    }

    if (size) {
        classNames.push(style[size])
    }

    const button: ReactElement = (
        <button
            type={type}
            onClick={onClick}
            className={classNames.join(' ')}
            style={{...customButtonColor, ...cssStyle}}
            onMouseEnter={() => setIsHover(true)}

            onMouseLeave={() => setIsHover(false)}
        >
            {children}
        </button>
    )

    if (actions.length === 0) {
        return button
    }

    return <div
        className={`${style.buttonWithDropdown} ${isOpen ? style.open : undefined} ${size ? style[size] : undefined}`}
        onMouseLeave={() => setOpen(false)}
    >
        {button}
        <button
            className={style.dropdownButton}
            onMouseEnter={() => setOpen(true)}
            onTouchStart={() => setOpen(!isOpen)}
        >
            <FontAwesomeIcon icon={faChevronDown}/>
        </button>
        <div className={style.dropdown}>
            {
                actions.map<ReactElement>(
                    (action: IAction, index: number): ReactElement => {
                        return <button className={style.button} onClick={action.onClick} key={`action${index}`}>
                            {action.label} {action.icon ? <FontAwesomeIcon icon={iconMap[action.icon]}/> : undefined}
                        </button>
                    }
                )
            }
        </div>
    </div>
}

export default Button
